import React, {memo} from "react";
//local
import {Info} from "components/Info";
import ComingSoon from "assets/images/svg/coming-soon.svg";
import {
  subscriptionPriceType,
  subscriptionPriceTypeDescription,
} from "constants/user.consts";

export const SubscriptionPriceInfo = memo(({subscription, t}) => (
  <div className="subscription__price">
    {subscription.isContactUs && (
      <span className="contact-us">{t("SUBSCRIPTION_TAB_CONTACT_DESCRIPTION")}</span>
    )}
    {!subscription.isContactUs && !subscription.isFake && (
      <React.Fragment>
        {subscription?.hasPeriods && (
          <span className="mr-2">{t("SUBSCRIPTION_TAB_PRICE_FROM")}</span>
        )}
        <span className="amount pr-2">
          {subscription.isCampaign && (
            <span className="offer-price">{subscription.price}</span>
          )}
          <span className={`price ${subscription.isCampaign ? "normal-price" : ""}`}>
            {subscription.isCampaign
              ? t("INACTIVE_PRICE_SUBSCRIPTION_NAME_06")
              : subscription.price}
          </span>
        </span>
        <span className="price-info">
          <span className="price-extras">
            <span className="price-type">
              {t(
                subscriptionPriceType[subscription.priceType] ??
                  subscriptionPriceType.PRICE_PER_MONTH
              )}
            </span>
            {subscription.isCampaign && (
              <span className="special-offer">{t("SUBSCRIPTION_PRICETYPE_INTRO")}</span>
            )}
          </span>
          {!subscription.isFree && (
            <Info
              tooltip={
                subscription.isCampaign
                  ? `INTRO_TOOLTIP_${subscription.name}`
                  : subscriptionPriceTypeDescription[subscription.priceType]
              }
              centerText
              addClass="ml-2"
            />
          )}
        </span>
      </React.Fragment>
    )}
    {!subscription.isContactUs && subscription.isFake && (
      <div className="subscription__coming-soon-star">
        <img src={ComingSoon} alt="" />
        <div className="subscription__coming-soon-star__text">
          {`${t("COMING_SOON_SPLASH_01")}\n${t("COMING_SOON_SPLASH_02")}`}
        </div>
      </div>
    )}
  </div>
));
